import { IAction } from '../sagas';
import { User } from '../models/user';
import { SIGNIN_SUCCESS, LOGOUT_SUCCESS, TOKEN_REQUEST_ERROR, SIGNIN_ERROR, TOKEN_SET_SUCCESS, REQUEST_USERS_SUCCESS, ADD_USER_SUCCESS, UPDATE_USER_SUCCESS, REMOVE_USER_SUCCESS} from '../handlers.actions';

const initUserStore: any = (): User => ({
    name: null,
    id: null,
    session: false,
    token: null,
    error: false,
    role: ''
});

const initUsersStore: any = () => ([]);

/** USER REDUCER */
export const userReducer = (state = initUserStore(), action: IAction) => {
    switch (action.type) {
         case SIGNIN_SUCCESS:
              return {
                   ...state,
                   ...action.payload
              }

         case SIGNIN_ERROR:
              return {
                   ...state,
                   ...action.payload
              }

         case LOGOUT_SUCCESS:
              return {
                   ...state,
                   ...action.payload
              }

         case TOKEN_REQUEST_ERROR:
              const user = {
                   token: null,
                   session: false
              }
              return {
                   ...state,
                   ...user
              }

         case TOKEN_SET_SUCCESS:
              return {
                   ...state,
                   ...action.payload
              }
         default:
              return state;
    }
}

/** USERS REDUCER */
export const usersReducer = (state = initUsersStore(), action: IAction) => {
     const {type, payload} = action;
     switch(type) {
          case ADD_USER_SUCCESS:
              return [
                   ...state.slice(0, payload),
                   payload,
                   ...state.slice(payload)
              ];

         case UPDATE_USER_SUCCESS:               
              return state.map((user: any) => {
                   if (user._id === payload._id) return payload;
                   return user;
              });

         case REMOVE_USER_SUCCESS:               
              return state.filter((user: any) => user._id !== payload._id); 
         
          case REQUEST_USERS_SUCCESS:               
               const merged = [...state, ...payload];
               const set = new Set();
               const unionArray = merged.filter((user:any) => {
                    if(!set.has(user._id)){
                         set.add(user._id);
                         return user.hasOwnProperty('status')?false:true; //Removed deleted accounts here
                    }
                    return false;
               }, set);              
               return [ ...unionArray ]; 
          default:
               return state;
     }
}